import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollTop";
import AboutUs from "./pages/AboutUs";
import BuildConstruction from "./pages/BuildConstruction";
import Contact from "./pages/Contact";
import EquippmentRent from "./pages/EquippmentRent";
import FirePage from "./pages/FirePage";
import Home from "./pages/Home";
import MaterialSupply from "./pages/MaterialSupply";
import ProductDetails from "./pages/ProductDetails";
import Products from "./pages/Products";
import ProjectDetail from "./pages/ProjectDetail";
import Projects from "./pages/Projects";
import QuoteRequestForm from "./pages/QuoteRequestForm";


function App() {
  return (
    <BrowserRouter>
     <ScrollToTop/>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs/>}/>
          <Route path="/products" element={<Products/>}/>
          <Route path="/products/:category/:id" element={<ProductDetails />} />
          <Route path="/projects" element={<Projects/>}/>
           <Route path="/projects/:projectTitle" element={<ProjectDetail/>} />
           <Route path="/services/build-construction" element={<BuildConstruction/>}/>
           <Route path="/services/fire-services" element={<FirePage/>}/>
           <Route path="/services/ict-and-security" element={<MaterialSupply/>}/>
           <Route path="/services/fumigation-services" element={<EquippmentRent/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/quote" element={<QuoteRequestForm/>}/>
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>

  );
}

export default App;
